module.exports = __webpack_public_path__ + "static/media/best-seller.4a0ddd5e.png";